import $ from "jquery";
import { application } from "../application/application";
import { dataaccess } from "../dataaccess/dataContext";
import { forms } from "../framework/forms";
import "jquery-mask-plugin";

let params;
let rejectReasonShown = 0;

function init() {
    //check that everything is filled in otherwise disable button
    $(document).on("click", "#resultsTab", function() {
        const $container = $("#results");
        const courseId = $("#courseId").val();

        dataaccess.get({ url: "/Course/courseresults/" + courseId })
            .done(function(data) {
                $container.html(data);
                $.validator.unobtrusive.parse($("#studentEvalsForm"));
                initPopovers();
                $(".js-mask-decimal").mask("0999999.99");
            });
    });

    $(document).on("submit", "#studentEvalsForm", function(e) {
        e.preventDefault();
        const $form = $(this);
        const $container = $("#results");

        if ($form.valid()) {
            const params = {
                contentType: dataaccess.contentType.APPLICATION_X_WWW_FORM_URLENCODED,
                data: $form.serialize(),
                url: $form.attr("action"),
                successMsg: "Successfully saved."
            };

            forms.showSpinner("Saving...", false);

            dataaccess.post(params)
                .fail(function(xhr, status, error) {
                    if (xhr.status === 400 && xhr.responseText !== "") {
                        $container.html(xhr.responseText);
                    }
                })
                .done(function(result) {
                    $("#divStudentEvals").html(result);
                    $.validator.unobtrusive.parse($("#studentEvalsForm"));
                })
                .always(function() {
                    forms.hideSpinner();
                });
        }
    });

    $(document).on("click", "#scheduleTab", function() {
        const container = $("#schedule");
        const courseId = $("#courseId").val();
        dataaccess.get({ url: "/Course/courseschedule/" + courseId }).done(function(data) {
            container.html(data);
        });
    });

    $(document).on("click", "#cancelCourseConfirmbtn", function() {
        const courseId = $("#courseId").val();
        params = {
            url: "/Course/cancelcourse/" + courseId,
            successMsg: "Successfully cancelled course."
        };
        dataaccess.post(params).done(function(data) {
            window.location.href = application.baseUrl + "/course/index/" + data.id;
        });
    });

    $(document).on("click", "#courseReportbtn", evtCourseReportBtnClick);

    $(document).on("change", "#courseStatusList", function() {
        const courseStatusId = $("#courseStatusList").val();
        const courseId = $("#courseId").val();
        params = {
            "url": "/Course/updatecoursestatus/" + courseStatusId + " / " + courseId,
            "successMsg": "Successfully updated course status."
        };
        dataaccess.post(params).done(function(data) {
            window.location.href = application.baseUrl + "/course/index/" + data.id;
        });
    });

    $(document).on("click", "#btnShowRejectComment", btnShowRejectCommentClick);
}

function evtCourseReportBtnClick() {
    const courseId = $("#courseId").val();
    $("#courseReportbtn").prop("disabled", true);
    forms.showSpinner("Processing...", false);
    params = {
        url: "/Course/checkcourseinfoiscomplete/" + courseId
    };
    dataaccess.get(params).done(function(results) {
        if (results.length > 0) {
            let alertMsg = "";
            for (let intx = 0; intx < results.length; intx++) {
                alertMsg = alertMsg + results[intx] + "\n";
            }
            forms.hideSpinner();
            $("#courseReportbtn").prop("disabled", false);
            alert(alertMsg);
        } else {
            params = {
                url: "/Course/submitpostcoursereport/" + courseId,
                successMsg: "Successfully submitted course closure report."
            };
            dataaccess.post(params).done(function(data) {
                window.location.href = application.baseUrl + "/course/index/" + data.id;
            });
            forms.hideSpinner();
        }
    });
}

function btnShowRejectCommentClick(e) {
    if (rejectReasonShown === 0) {
        $("#btnShowRejectComment").popover("show");
        rejectReasonShown = 1;
    } else {
        $("#btnShowRejectComment").popover("hide");
        rejectReasonShown = 0;
    }
}

function initPopovers() {
    $(".commentIcon").popover({
        html: true,
        sanitize: false
    });

    $(document).on("click", ".commentIcon", function() {
        $(".commentIcon")
            .not($(this))
            .popover("hide");
    });
}

export const courseProfile = {
    init: init,
    initPopovers: initPopovers
};
